import { createDarkTheme } from "@comparaonline/ui-theme";
import { MuiThemeProvider } from "@material-ui/core/styles";
import React, { useMemo } from "react";
import { useWidgetHeroConfig, useWidgetMuiFabStyles } from "../../hooks";

import { LandingBreadcrumbs } from "../../../../../common/components/Breadcrumbs";
import { Container, BaseHeroProps } from "./Container";

export const BaseHero: React.FC<BaseHeroProps> = ({ children, className, ...rest }) => {
  const config = useWidgetHeroConfig();
  const MuiFabOverrides = useWidgetMuiFabStyles();
  const theme = useMemo(
    () =>
      createDarkTheme({
        overrides: {
          ...MuiFabOverrides
        }
      }),
    [config]
  );

  return (
    <MuiThemeProvider theme={theme}>
      <Container
        className={className}
        backgroundColor={config.backgroundColor}
        backgroundUrl={config.textureUrl}
        {...rest}
      >
        <LandingBreadcrumbs />
        {children}
      </Container>
    </MuiThemeProvider>
  );
};
